import React, { useCallback, useEffect, useState } from 'react'
import { Breadcrumb, MenuAccount } from '../../components/Main'
import { useTranslation } from 'react-i18next'
import { InteractorReturnSearch } from '../../interactors/Main'
import { Link } from 'react-router-dom'
import WideCardReturn from '../../components/widecard/WideCardReturn'
import { useSelector } from 'react-redux'

const ReturnIndex = () => {
  const { t } = useTranslation()
  const pathSegments = window.location.pathname.split('/')
  const uid = pathSegments[pathSegments.length - 1]
  const { account } = useSelector((state) => state.account)
  const { returnSearch } = InteractorReturnSearch()
  const [pagination, setPagination] = useState()
  const [loading, setLoading] = useState(true)
  const [download] = useState({
    headers: null,
    items: null,
    filename: null,
  })
  const [datacard, setDatacard] = useState([])
  const [payload, setPayload] = useState({
    page: 1,
    limit: 5,
    keywords: {
      text_search: '',
      status: '',
      account_uid: account?.uid,
      store_uid: '',
      uid: '',
      transaction_uid: '',
    },
  })

  const handleCsv = useCallback((data) => {
    // csvOrder(data.items, setDownload)
  }, [])

  const handleResponse = useCallback(
    (data) => {
      setDatacard(data)
      setPagination(data.pages)
      // CSV
      var payloadCsv = { ...payload }
      payloadCsv.limit = data?.pages.limit ?? 0
      returnSearch(payloadCsv, handleCsv, () => null)
    },
    [returnSearch, handleCsv, payload],
  )

  useEffect(() => {
    if (loading) {
      returnSearch(payload, handleResponse, setLoading)
    }
  }, [returnSearch, handleResponse, loading, payload])

  const handleFilter = (row) => {
    setPayload(row)
    setDatacard([])
    setLoading(true)
  }

  const handleLimitChange = (newLimit) => {
    setPayload((prev) => ({ ...prev, limit: newLimit }))
    setLoading(true)
  }

  const handlePageChange = (newPage) => {
    setPayload((prev) => ({ ...prev, page: newPage }))
    setLoading(true)
  }

  return (
    <>
      <Breadcrumb title={t('menu.return')} className="mb-4" />
      <div className="container">
        <div className="row mb-8">
          <MenuAccount />
          <div className="col-xl-9 col-wd-9gdot5">
            <div className="flex-center-between mt-2 mt-0-lg">
              <h3 className="font-size-20 font-size-20-lg font-weight-bold mb-0">
                {t('menu.return')}
              </h3>
            </div>
            <hr />
            <WideCardReturn
              loading={loading}
              datacard={datacard}
              payload={payload}
              handleFilter={handleFilter}
              download={false}
              pagination={pagination}
              onPageChange={handlePageChange}
              onLimitChange={handleLimitChange}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ReturnIndex
